export class Guardian {
    firstname:string=""
    lastname:string=""
    fullname:string=""
    email:string=""
    server_user_id=0
    server_guardian_id=0
    students=[]
    enrolments=[]
    enrolment_count:0
    isOnTrial=false
    
}
